import React from "react";
import styles from "./ScrollDownAnimatedArrows.module.css";

type ScrollDownProps = {
  /** Optional: override how far to scroll. Default: one viewport height */
  scrollTop?: number;
  /** Optional: additional className merged with styles.scrollDown */
  contClassName?: string;
  clickAreaClassName?: string;
  /** Optional: id attribute */
  id?: string;
};

export function ScrollDownAnimatedArrows({
  scrollTop,
  contClassName,
  clickAreaClassName,
  id = "scroll-down",
}: ScrollDownProps) {
  const handleClick = () => {
    const top = typeof scrollTop === "number" ? scrollTop : window.scrollY + window.innerHeight;
    window.scrollTo({ top, behavior: "smooth" });
  };

  return (

    <div className={[styles.scrollDownClickArea, styles[clickAreaClassName || ""]].filter(Boolean).join(" ")} onClick={handleClick}   role="button"   onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") handleClick();
    }}>
      <div
        id={id}
        className={[styles.scrollDown, styles[contClassName || ""]].filter(Boolean).join(" ")}

        role="button"
        tabIndex={0}
        aria-label="Scroll down"

      >
        {Array.from({ length: 4 }).map((_, i) => (
          <svg key={i} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 4">
            <path d="M 0 0 L 0 2 L 4 4 L 8 2 L 8 0 L 4 2 Z" />
          </svg>
        ))}
      </div>
    </div>


  );
}
